<template>
    <div>
        <v-card class="p-3 flex-fill h-100 w-100">
            <div class="d-flex justify-content-between mb-3">
                <h5>Contacts</h5>

                <div class="d-flex justify-content-between gap-10">

                    <v-btn outlined class="custom-button-primary"
                           style="height: 36px;min-width: 42px;padding: 0"
                           @click="prepareOpenModal()">
                        <v-icon color="primary">person_add</v-icon>
                    </v-btn>
                </div>
            </div>

            <div class="text-center" v-if="contacts.length === 0">
                <small>
                    Aucun contact associé
                </small>
            </div>

            <div v-else class="d-flex flex-wrap gap-15">
                <v-card class="bg-light px-0 pb-0 w-auto h-auto"
                        style="flex: 0 0 calc(50% - 8px); max-width: calc(50% - 8px);"
                        v-for="contact in contacts" :key="contact.id">
                    <v-card-title class="d-flex justify-content-between px-2 py-0">
                        <h6 v-if="contact.first_name || contact.last_name"
                            style="flex: 1; white-space: normal; word-break: break-word; margin: 0;">
                            {{contact.first_name}} {{contact.last_name}}
                        </h6>

                        <h6 v-else></h6>

                        <v-menu bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item @click="prepareOpenModal(contact)">
                                    <v-list-item-title>
                                        <v-icon color="primary">edit</v-icon>
                                        Editer
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="deleteContact(contact.id)">
                                    <v-list-item-title>
                                        <v-icon color="error">delete</v-icon>
                                        Supprimer
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-title>

                    <v-card-text class="px-2 d-flex flex-column">
                        <div v-if="contact.professions && contact.professions.length" class="mb-2">
                            <v-icon color="primary" left>assignment</v-icon>
                            <span class="mt-auto mb-auto">
                               {{ contact.professions.map(p => p.label).join(', ') }}
                            </span>
                        </div>
                        <div v-if="contact.email" class="mb-2">
                            <v-icon color="primary" left>email</v-icon>
                            <span class="mt-auto mb-auto">
                               {{contact.email}}
                            </span>
                        </div>
                        <div v-if="contact.phone">
                            <v-icon color="primary" left>phone</v-icon>
                            <span class="mt-auto mb-auto">
                                {{contact.phone}}
                            </span>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </v-card>

        <v-dialog v-model="editModal" persistent max-width="900px">
            <v-card>
                <v-card-title class="d-flex justify-content-between">
                    <div>
                        <span class="headline" v-if="currentContact.id">Edition du contact</span>
                        <span class="headline" v-else>Création du contact</span>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field outlined label="Prénom" hide-details
                                          v-model="currentContact.first_name">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field outlined label="Nom" hide-details
                                          v-model="currentContact.last_name">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-select :items="professions"
                                      outlined
                                      multiple
                                      chips
                                      small-chips
                                      deletable-chips
                                      label=" Fonction"
                                      hide-details
                                      v-model="currentContact.professions"
                                      item-text="label"
                                      item-value="id"
                                      return-object>
                            </v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field outlined label="E-mail"
                                          :class="{'input-error': isConfirmed && !isValidEmail}"
                                          hide-details v-model="currentContact.email">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <v-text-field outlined label="Téléphone" hide-details
                                          v-model="currentContact.phone">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field outlined label="Téléphone (2)" hide-details
                                          v-model="currentContact.phone_2">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field outlined label="Adresse"
                                          hide-details v-model="currentContact.address">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6">
                            <v-text-field outlined label="Ville" hide-details
                                          v-model="currentContact.commune">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field outlined label="Code postal" hide-details
                                          v-model="currentContact.postal_code">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field outlined label="Province"
                                          hide-details v-model="currentContact.province">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="closeModal">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="checkEmailFormat"
                        v-if="currentContact.id" :disabled="isConfirmed && !isValidEmail">
                            Modifier le contact
                        </v-btn>
                        <v-btn class="default-button custom-button-primary" @click="checkEmailFormat"
                               :disabled="isConfirmed && !isValidEmail" v-else>
                            Créer le contact
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import Confirm from "../tools/Confirm.vue"
import * as EmailValidator from "email-validator"
export default {
    name: "EntityContactsBloc",
    props: ["entityId"],
    components: { Confirm, },
    data() {
        return {
            currentContact: {
                id : null,
                first_name: null,
                last_name: null,
                phone: null,
                phone_2: null,
                email: null,
                professions: [],
                address: null,
                commune: null,
                postal_code: null,
                province: null,
            },
            editModal: false,
            contacts: [],
            professions: [],
            isConfirmed: false,
        }
    },
    methods: {
        prepareOpenModal(contact = null) {
            if (contact) {
                this.currentContact = JSON.parse(JSON.stringify(contact))
            }

            this.editModal = true;
        },
        closeModal () {
            this.currentContact = {
                id : null,
                first_name: null,
                last_name: null,
                phone: null,
                phone_2: null,
                email: null,
                professions: [],
                address: null,
                commune: null,
                postal_code: null,
                province: null,
            }
            this.isConfirmed = false

            this.editModal = false;
        },
        getEntityContacts() {
            this.$http.get("auth/sit-entity/entity-contacts/" + this.entityId).then(res => {
                this.contacts = res.body.data.entityContacts
            })
        },
        getProfessions() {
            this.$http.get("resource/professions").then(res => {
                this.professions = res.body.data.professions
            })
        },
        createContact() {
            let payload = {
                entityId: this.entityId,
                firstName: this.currentContact.first_name,
                lastName: this.currentContact.last_name,
                phone: this.currentContact.phone,
                phone_2: this.currentContact.phone_2,
                email: this.currentContact.email,
                address: this.currentContact.address,
                city: this.currentContact.commune,
                postalCode: this.currentContact.postal_code,
                province: this.currentContact.province,
                functionIds: (this.currentContact.professions || []).map(p => p.id),
            }

            this.$global.loading = true

            this.$http.post("auth/sit-entity/entity-contacts", payload).then(res => {
                this.getEntityContacts()
                this.closeModal()

                this.$global.loading = false
            })
        },
        updateContact() {
            let payload = {
                contactId: this.currentContact.id,
                firstName: this.currentContact.first_name,
                lastName: this.currentContact.last_name,
                phone: this.currentContact.phone,
                phone_2: this.currentContact.phone_2,
                email: this.currentContact.email,
                address: this.currentContact.address,
                city: this.currentContact.commune,
                postalCode: this.currentContact.postal_code,
                province: this.currentContact.province,
                functionIds: (this.currentContact.professions || []).map(p => p.id),
            }

            this.$global.loading = true

            this.$http.put("auth/sit-entity/entity-contacts", payload).then(res => {
                this.getEntityContacts()
                this.closeModal()

                this.$global.loading = false
            })
        },
        deleteContact(id) {
            this.$refs.confirm.open('Suppression du contact',
              'Êtes-vous sûr de vouloir supprimer le contact ?',
              { color: 'error', cancelColor: '#0b697e', confirmColor: 'error' }).
            then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    this.$http.delete("auth/sit-entity/entity-contacts/" + id).then(res => {
                        this.getEntityContacts()
                        this.closeModal()

                        this.$global.loading = false
                    })
                }
            })
        },
        checkEmailFormat() {
            this.isConfirmed = true

            if(this.isValidEmail && this.currentContact.id) {
                this.updateContact()
            } else if (this.isValidEmail && !this.currentContact.id) {
                this.createContact()
            }
        },
    },
    computed: {
        isValidEmail() {
            return EmailValidator.validate(this.currentContact.email) || this.currentContact.email === null ||
              this.currentContact.email === ''
        },
    },
    created () {
        this.getEntityContacts()
        this.getProfessions()
    }
}
</script>
